import { AppPage } from "@/layouts/page";
import { ZeroResultSearchTable } from "@/components/zero-result-search/table";
import { useGetZeroResultQueries } from "@/hooks/api/zero-result-search/useGetZeroResultQueries";
import { useUpdateZeroResultQueryStatus } from "@/hooks/api/zero-result-search/useUpdateZeroResultQueryStatus";
import { useZeroResultSearchFilters } from "@/hooks/useZeroResultSearchFilters";
import type { ZeroResultQueryStatus } from "@/types";

export function ZeroResultSearchesPage() {
  const { filters, setFilter, setFilters, clearFilters } =
    useZeroResultSearchFilters();
  const { data, isFetching } = useGetZeroResultQueries(filters);
  const updateStatus = useUpdateZeroResultQueryStatus();

  const handlePageChange = (newPage: number) => {
    setFilter("page", newPage);
  };

  const handleLimitChange = (newLimit: number) => {
    setFilters({ limit: newLimit, page: 1 });
  };

  const handleStatusChange = (id: string, status: ZeroResultQueryStatus) => {
    updateStatus.mutate({ id, status });
  };

  const total = data?.total;

  return (
    <AppPage
      subtitle={
        total === undefined
          ? undefined
          : `${total.toLocaleString()} search terms that returned no products`
      }
      title="Zero Result Searches"
    >
      <ZeroResultSearchTable
        changePage={handlePageChange}
        clearFilters={clearFilters}
        filters={filters}
        isLoading={isFetching && !data}
        isStatusUpdating={updateStatus.isPending}
        items={data?.data ?? []}
        limit={filters.limit ?? 10}
        page={filters.page ?? 1}
        setFilter={setFilter}
        setFilters={setFilters}
        totalItems={total ?? 0}
        onLimitChange={handleLimitChange}
        onStatusChange={handleStatusChange}
      />
    </AppPage>
  );
}
